const validationRule: Object = { required: true };
const validationNumberRule: Object = { required: true, number: true };
export const misfiresColumns = [
  {
    field: 'id',
    headerText: 'ID',
    width: '100',
    textAlign: 'Left',
    isPrimary: true,
    visible: false,
    allowEditing:false,
  },
  {
    field: 'pitt',
    validationRules: validationRule,
    headerText: 'Pit',
    allowEditing:true,
  },
  {
    field: 'shot_id',
    validationRules: validationNumberRule,
    headerText: 'Shot ID',
    allowEditing:true,
    editType:'numericedit'
  },
  {
    field: 'no_holes',
    validationRules: validationRule,
    headerText: 'No.Holes',
    allowEditing:true,
  },
  {
    field: 'product',
    validationRules: validationRule,
    headerText: 'Product',
    allowEditing:true,
  },
  {
    field: 'rectified',
    validationRules: validationRule,
    headerText: 'Rectified',
    allowEditing:true,
  },
  {
    field: 'eos_status',
    validationRules: validationRule,
    headerText: 'EOS Status',
    allowEditing:true,
  },
];
